export enum AvailabilitiesType {
    NORMAL = 'NORMAL',
    DETAIL = 'DETAIL'
}
